<template>
  <footer class="l-ft fixed bottom-0 left-0 z-[1] w-full">
    <div class="m-ft relative mx-auto w-full max-w-[600px]">
      <div id="footer-fix">
        <!-- 需要 Fix 的用 Teleport 移動至這裡 -->
      </div>
      <div class="bg-white p-[4px]">
        <p
          class="text-center text-[12px] font-light tracking-[0.4em] text-[var(--color-title-footer)]"
        >
          尚格酒業獨家代理
        </p>
      </div>
      <div
        class="flex h-[50px] w-full items-center justify-center bg-[var(--bg-footer)] font-light tracking-[0.2em]"
      >
        <p class="text-[20px] text-[var(--color-footer)]">禁止酒駕</p>
        <figure class="p-[4px]">
          <img
            src="@/assets/img/nodrunkdriving.svg"
            class="h-[30px] w-[30px]"
            alt="nodrunkdriving"
          />
        </figure>
        <p class="text-[20px] text-[var(--color-footer)]">未滿十八歲禁止飲酒</p>
      </div>
    </div>
  </footer>
</template>

<script setup>
</script>

<style lang="postcss">
.l-ft {
  transform: translateZ(1px);
}

.dalmore {
  --color-title-footer: #8A8D8F;
  --bg-footer: #C5C6C7;
}

.jura {
  --color-title-footer: #8A8D8F;
  --bg-footer: #C5C6C7;
}

.fettercairn {
  --color-title-footer: #ACACAC;
  --color-footer: #FFFFFF;
  --bg-footer: #00AAA1;

  .m-ft {
    box-shadow : 0 0 15px #00000033
  }
}

.tamnavulin {
  --color-title-footer: #ACACAC;
  --color-footer: #FFFFFF;
  --bg-footer: #3E3127;

  .m-ft {
    box-shadow : 0 0 15px #00000033
  }
}
</style>
